import React, { useEffect, useState } from "react";
import { Typography, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "./TextDecrypt";
import Resume from "../../settings/resume.json";
import { FirstName } from "../../utils/getName";

const useStyles = makeStyles((theme) => ({
    main: {
        marginTop: "150px",
        marginBottom: "80px",
        // marginLeft: "30px",
        // marginRight: "30px",
        // Commented: looks bad on mobile (seems getting negative margin at right)
        // // marginLeft: "35vw",
        // "@media (max-width: 768px)": {
        //     marginLeft: theme.spacing(4)
        // },
    },
}));

export const Content = () => {
    const classes = useStyles();
    const [showShortStory0, setShowShortStory0] = useState(false);
    const [showShortStory1, setShowShortStory1] = useState(false);
    const [showShortStory2, setShowShortStory2] = useState(false);
    const [showShortStory3, setShowShortStory3] = useState(false);

    useEffect(() => {
        const timer0 = setTimeout(() => {
            setShowShortStory0(true);
        }, 500);
        const timer1 = setTimeout(() => {
            setShowShortStory1(true);
        }, 2500);
        // const timer2 = setTimeout(() => {
        //     setShowShortStory2(true);
        // }, 8000);
        // const timer3 = setTimeout(() => {
        //     setShowShortStory3(true);
        // }, 20000);

        // Clean up on component unmount
        return () => {
            clearTimeout(timer0);
            clearTimeout(timer1);
            // clearTimeout(timer2);
            // clearTimeout(timer3);
        };
    }, []); // Only run once after initial render

    return (
        <Container component="main" className={`${classes.main}`} maxWidth="md">
            <Typography variant="h2" component="h1" gutterBottom>
                {/* <TextDecrypt text={`${Resume.basics.x_title} ${FirstName}`} /> */}
                {`${Resume.basics.x_title} ${FirstName}`}
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
                {/* <TextDecrypt text={`a ${Resume.basics.job}`} /> */}
                {/* <TextDecrypt text={`${Resume.basics.job}`} /> */}
                <a href="https://devpost.com/xucian" target="_blank" rel="noopener noreferrer" className="modern-link">{`${Resume.basics.job}`}</a>
                {/* <TextDecrypt text={`from ${Resume.basics.location.country}`} /> */}
                {/* <TextDecrypt text={`from ${Resume.basics.location.city}`} /> */}
            </Typography>
            <br/>
            <Typography variant="h6" component="h3" gutterBottom>
                {/* <TextDecrypt text="I love finding boxes that I can think out of" /> */}
                <p className={`fade-in ${showShortStory0 ? 'show' : ''}`} align="right">I love finding boxes that I can think out of</p>
            </Typography>
            <br/>
            <Typography variant="h6" component="h3" gutterBottom>
                {/* <p className={`fade-in ${showShortStory1 ? 'show' : ''}`}>{`${Resume.basics.short_story}`}</p> */}
                <p className={`fade-in ${showShortStory1 ? 'show' : ''}`}>
                    scripted cs16 servers in <a href='https://www.youtube.com/watch?v=MdjHiO5Q-RI' target="_blank" rel="noopener noreferrer" className="modern-link">'06</a>, hardcore gamedev since '13, devops/backend/ai generalist since '19
                    </p>
            </Typography>
            <br/>
            <Typography variant="h6" component="h3" gutterBottom>
                <p className={`fade-in ${showShortStory1 ? 'show' : ''}`}>
                    fav quote: when the winds of change blow, some people build walls and others build windmills
                </p>
            </Typography>
        </Container>
    );
};
